import React, { useEffect, useState } from 'react'
import { Box, Switch, Text } from '@chakra-ui/react'
import CustomRadio from '@/common/CustomRadio';
import { DefaultFilters, FFLDistanceComponent, FFLSortComponent } from '@masterffl/ffl-search-v2-component';
import { keyType } from '@/queue/types';
import { useDispatch } from 'react-redux';
import { callToGetStoreFilterConfigData } from '@/queue/ducks/slice';
import { setIsStoreFilterConfigChanged, setUpdatedStoreFilterConfig } from '../ducks/slice';
import { getIsStoreFilterConfigChanged, getStoreFilterConfig, getUpdatedStoreFilterConfig } from '../ducks/selectors';
import { FilterConfigItem, FilterConfiguration, StoreFilterConfig, sortBy } from '../types';
import { isUndefined } from 'lodash'

const ratingListMapping: any = {
    all: 'All',
    '4': <>4 &#9733; and above</>,
    '3': <>3 &#9733; and above</>,
    '2': <>2 &#9733; and above</>,
    '1': <>1 &#9733; and above</>,
};


const FFLSelectFiltersConfiguration = ({callAPI, setCallAPI}:{callAPI:boolean,setCallAPI:(val:boolean)=>void}) => {
    const [licenseTypes, setLicenseTypes] = useState<Array<FilterConfigItem>>(
        JSON.parse(JSON.stringify(DefaultFilters.typeListMapping)).filter(
            (item: FilterConfigItem) => item.id !== 'license_type_03'
        )
    );
    const [gunTypes, setGunTypes] = useState<Array<FilterConfigItem>>(JSON.parse(JSON.stringify(DefaultFilters.gunTypeList)));
    const [licenseDetails, setLicenseDetails] = useState<Array<FilterConfigItem>>(JSON.parse(JSON.stringify(DefaultFilters.licenseDetails)));
    const [ratings, setRatings] = useState<Array<FilterConfigItem>>(JSON.parse(JSON.stringify(DefaultFilters.ratingList)));
    const [reviews, setReviews] = useState<Array<FilterConfigItem>>(JSON.parse(JSON.stringify(DefaultFilters.reviewList)));
    const [dealerType, setDealerType] = useState<Array<FilterConfigItem>>(JSON.parse(JSON.stringify(DefaultFilters.rangesStocks)));
    const [sot, setSOT] = useState<Array<FilterConfigItem>>(JSON.parse(JSON.stringify(DefaultFilters.sotFilters)));
    const [services, setServices] = useState<Array<FilterConfigItem>>(JSON.parse(JSON.stringify(DefaultFilters.servicesFilters)));
    const [filterConfiguration, setFilterConfiguration] = useState<FilterConfiguration | null>(null)
    const [distance, setDistance] = useState(5);
    const [sortBy, setSortBy] = useState({sortBy: 'preferred' })
    const dispatch = useDispatch();
    const storeFilterConfig = getStoreFilterConfig();
    const isFilterConfigChanged = getIsStoreFilterConfigChanged();
    
    const updateConfigFunc = (configure: FilterConfigItem[] | undefined, defaultFilter: FilterConfigItem[]) => {
    if (configure) {
        let arrObj = defaultFilter.map((filter:FilterConfigItem) => {
            const configureMatch = configure.find((conf:FilterConfigItem) => conf.id === filter.id);
            return configureMatch ? { ...filter, ...configureMatch } : filter;
        });
        return arrObj;
    }
    return defaultFilter;
    }
    useEffect(() => {
        dispatch(callToGetStoreFilterConfigData({}));
    },[])
    useEffect(() => {
        if (storeFilterConfig) {
            setFilterConfiguration(storeFilterConfig.filter_config)
        }
    }, [storeFilterConfig])
    
    const ResetConfiguration = (filterConfiguration: FilterConfiguration | null) => {
        let returnLicenseTypeValue = updateConfigFunc(filterConfiguration?.license_type, JSON.parse(JSON.stringify(DefaultFilters.typeListMapping)))
        
        setLicenseTypes(returnLicenseTypeValue)
        let returnfirearmTypeValue = updateConfigFunc(filterConfiguration?.firearm_type, JSON.parse(JSON.stringify(DefaultFilters.gunTypeList)))
        setGunTypes(returnfirearmTypeValue)
        let returnLicenseDetailsValue = updateConfigFunc(filterConfiguration?.license_details, JSON.parse(JSON.stringify(DefaultFilters.licenseDetails)))
        setLicenseDetails(returnLicenseDetailsValue)
        let returnReviewValue = updateConfigFunc(filterConfiguration?.review, JSON.parse(JSON.stringify(DefaultFilters.reviewList)))
        setReviews(returnReviewValue)
        let returnRatingValue = updateConfigFunc(filterConfiguration?.rating, JSON.parse(JSON.stringify(DefaultFilters.ratingList)))
        setRatings(returnRatingValue)
        let returnDealerTypeValue = updateConfigFunc(filterConfiguration?.dealer_type, JSON.parse(JSON.stringify(DefaultFilters.rangesStocks)))
        setDealerType(returnDealerTypeValue)
        let returnSOTFilters = updateConfigFunc(filterConfiguration?.sot, JSON.parse(JSON.stringify(DefaultFilters.sotFilters)))
        setSOT(returnSOTFilters)
        let returnServicesFilters = updateConfigFunc(filterConfiguration?.services, JSON.parse(JSON.stringify(DefaultFilters.servicesFilters)))
        setServices(returnServicesFilters)
        setCallAPI(false)
    }

    const UpdateConfigurationDetails = (filterConfiguration:FilterConfiguration | null) => {
        if (filterConfiguration?.license_type) {
            let returnValue = updateConfigFunc(filterConfiguration?.license_type, licenseTypes)
            setLicenseTypes(returnValue)
        }
        if (filterConfiguration?.firearm_type) {
            let returnValue = updateConfigFunc(filterConfiguration?.firearm_type, gunTypes)
            setGunTypes(returnValue)
        }
        if (filterConfiguration?.license_details) {
            let returnValue = updateConfigFunc(filterConfiguration?.license_details, licenseDetails)
            setLicenseDetails(returnValue)
        }
        if (filterConfiguration?.review) {
            let returnValue = updateConfigFunc(filterConfiguration?.review, reviews)
            setReviews(returnValue)
        }
        if (filterConfiguration?.rating) {
            let returnValue = updateConfigFunc(filterConfiguration?.rating, ratings)
            setRatings(returnValue)
        }
        if (filterConfiguration?.dealer_type) {
            let returnValue = updateConfigFunc(filterConfiguration?.dealer_type, dealerType)
            setDealerType(returnValue)
        }
        if (filterConfiguration?.sot) {
            let returnValue = updateConfigFunc(filterConfiguration?.sot, sot)
            setSOT(returnValue)
        }
        if (filterConfiguration?.services) {
            let returnValue = updateConfigFunc(filterConfiguration?.services, services)
            setServices(returnValue)
        }
        if (filterConfiguration?.defaultDistance) setDistance(filterConfiguration?.defaultDistance)
        if (filterConfiguration?.defaultSortBy) setSortBy(filterConfiguration?.defaultSortBy)
    }
    useEffect(() => {
        if (!isFilterConfigChanged && callAPI) {
            ResetConfiguration(filterConfiguration);
        }
    }, [isFilterConfigChanged])
    
    useEffect(() => {
        if (filterConfiguration) {
            UpdateConfigurationDetails(filterConfiguration)
        }
    }, [filterConfiguration]);


    const updateFilterConfigureList = (type: any) => {
        return type.filter((item:any) => (item.default || item.invisible)).map((item:any) => ({ id: item.id, ...(isUndefined(item.default) ? {}: {default: item.default}), ...(isUndefined(item.invisible) ? {}: {invisible: item.invisible}) }))
    }
    useEffect(() => {
        let obj:FilterConfiguration = {}
        if (updateFilterConfigureList(licenseTypes).length > 0) {
            obj.license_type = updateFilterConfigureList(licenseTypes)
        }
        if (updateFilterConfigureList(gunTypes).length > 0) {
            obj.firearm_type = updateFilterConfigureList(gunTypes)
        }
        if (updateFilterConfigureList(licenseDetails).length > 0) {
            obj.license_details = updateFilterConfigureList(licenseDetails)
        }
        if (updateFilterConfigureList(ratings).length > 0) {
            obj.rating = updateFilterConfigureList(ratings)
        }
        if (updateFilterConfigureList(reviews).length > 0) {
            obj.review = updateFilterConfigureList(reviews)
        }
        if (updateFilterConfigureList(dealerType).length > 0) {
            obj.dealer_type = updateFilterConfigureList(dealerType)
        }
        if (updateFilterConfigureList(sot).length > 0) {
            obj.sot = updateFilterConfigureList(sot)
        }
        if (updateFilterConfigureList(services).length > 0) {
            obj.services = updateFilterConfigureList(services)
        }
        if (distance) obj.defaultDistance = distance
        if (sortBy) obj.defaultSortBy = sortBy

      dispatch(setUpdatedStoreFilterConfig({filter_config:obj} as any))
    }, [licenseTypes,gunTypes,licenseDetails,ratings,reviews,dealerType,sot,distance,sortBy, services])
    
    const onToggleChanged = (index: number, prevState: Array<FilterConfigItem>, type: string) => {
        const updatedMapping = [...prevState];
        if (type == 'invisible') {
            updatedMapping[index].invisible = !updatedMapping[index].invisible;
        } else {
            updatedMapping[index].default = !updatedMapping[index].default;
        }
        dispatch(setIsStoreFilterConfigChanged(true));
        return updatedMapping;
    }
    const onToggleRattingReview = (index: number, prevState: any) => {
        const updatedMapping = [...prevState];
        updatedMapping.forEach(rat => { rat.default = false });
        updatedMapping[index].default = true;
        dispatch(setIsStoreFilterConfigChanged(true));
        return updatedMapping;
    }
    const onChangeLicenseTypes = (index: number, type: string) => () => {
        setLicenseTypes(prevState => onToggleChanged(index, prevState, type));
    };
    const onChangeGunTypes = (index: number, type: string) => () => {
        setGunTypes(prevState => onToggleChanged(index, prevState, type));
    };
    const onChangeLicenseDetails = (index: number, type: string) => () => {
        setLicenseDetails(prevState => onToggleChanged(index, prevState, type));
    };
    const onChangeRatings = (index: number, type: string) => () => {
        if (type == 'invisible') {
            setRatings(prevState => onToggleChanged(index, prevState, type));
        } else {
            setRatings(prevState => onToggleRattingReview(index, prevState));
        }
    };
    const onChangeReviews = (index: number, type: string) => () => {
        if (type == 'invisible') {
            setReviews(prevState => onToggleChanged(index, prevState, type));
        } else {
            setReviews(prevState => onToggleRattingReview(index, prevState));
        }
    };
    const onChangeDealerType = (index: number, type: string) => () => {
        setDealerType(prevState => onToggleChanged(index, prevState, type));
    };
    const onChangeSOT = (index: number, type: string) => () => {
        setSOT(prevState => onToggleChanged(index, prevState, type));
    };
    const onChangeServices = (index: number, type: string) => () => {
        setServices(prevState => onToggleChanged(index, prevState, type));
    };
    const handleDistance = (val: number) => {
        setDistance(val);
        dispatch(setIsStoreFilterConfigChanged(true));
    }
    const handleSortBy = (val: sortBy) => {
        setSortBy(val);
        dispatch(setIsStoreFilterConfigChanged(true));
    }
    return (
      <>
        <Box className='default-filters-container'>
          <Box className='default-filter-box-container'>
            <Box className='item-container'>
              <Box className='item-row'>
                <Text className='filter_text'>Default Search Radius</Text>
                <FFLDistanceComponent inputDistance={distance} isFiltersDisabled={false} onChangeDistance={handleDistance} />
              </Box>
            </Box>
          </Box>
          <Box className='default-filter-box-container'>
            <Box className='item-container'>
              <Box className='item-row'>
                <Text className='filter_text'>Default Sort By</Text>
                <FFLSortComponent isFiltersDisabled = {false} searchRecognizer = {undefined}  sortParams={sortBy}  onSortOptionsChange = {handleSortBy} />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className='filters-container'>
            <Box className='filter-box-container'>
                <Box className='gray-header'>
                    <Text className='black_label' sx={{ width: '60%' }}>All Filters</Text>
                    <Text className='black_label' sx={{ width: '20%' }}>Visible</Text>
                    <Text className='black_label' sx={{ width: '20%' }}>Default</Text>
                </Box>
                <Box className='blue-header'>
                    <Text className='white_label'>License Type</Text>
                </Box>
                <Box className='item-container'>
                    {licenseTypes.map((ele: FilterConfigItem, index: number) => (
                        <Box className='item-row' key={`filter_type_${index}`}>
                            <Text className='filter_text' sx={{ width: '60%' }}>{ele.label}</Text>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeLicenseTypes(index, 'invisible')}
                                    isChecked={!(ele?.invisible)}
                                />
                            </Box>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeLicenseTypes(index, 'default')}
                                    isChecked={!!(ele?.default)}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Box className='blue-header'>
                    <Text className='white_label'>Gun Type</Text>
                </Box>
                <Box className='item-container'>
                    {gunTypes.map((ele: FilterConfigItem, index: number) => (
                        <Box className='item-row' key={`filter_type_${index}`}>
                            <Text className='filter_text' sx={{ width: '60%' }}>{ele.label}</Text>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeGunTypes(index, 'invisible')}
                                    isChecked={!(ele?.invisible)}
                                />
                            </Box>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeGunTypes(index, 'default')}
                                    isChecked={!!(ele?.default)}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Box className='blue-header'>
                    <Text className='white_label'>Dealer Type</Text>
                </Box>
                <Box className='item-container'>
                    {dealerType.map((ele: FilterConfigItem, index: number) => (
                        <Box className='item-row' key={`filter_type_${index}`}>
                            <Text className='filter_text' sx={{ width: '60%' }}>{ele.label}</Text>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeDealerType(index, 'invisible')}
                                    isChecked={!(ele?.invisible)}
                                />
                            </Box>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeDealerType(index, 'default')}
                                    isChecked={!!(ele?.default)}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Box className='blue-header'>
                    <Text className='white_label'>SOT</Text>
                </Box>
                <Box className='item-container'>
                    {sot.map((ele: FilterConfigItem, index: number) => (
                        <Box className='item-row' key={`filter_type_${index}`}>
                            <Text className='filter_text' sx={{ width: '60%' }}>{ele.label}</Text>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeSOT(index, 'invisible')}
                                    isChecked={!(ele?.invisible)}
                                />
                            </Box>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeSOT(index, 'default')}
                                    isChecked={!!(ele?.default)}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Box className='blue-header'>
                    <Text className='white_label'>SERVICES</Text>
                </Box>
                <Box className='item-container'>
                    {services.map((ele: FilterConfigItem, index: number) => (
                        <Box className='item-row' key={`filter_type_${index}`}>
                            <Text className='filter_text' sx={{ width: '60%' }}>{ele.label}</Text>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeServices(index, 'invisible')}
                                    isChecked={!(ele?.invisible)}
                                />
                            </Box>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeServices(index, 'default')}
                                    isChecked={!!(ele?.default)}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Box className='filter-box-container'>
                <Box className='gray-header'>
                    <Text className='black_label' sx={{ width: '60%' }}>All Filters</Text>
                    <Text className='black_label' sx={{ width: '20%' }}>Visible</Text>
                    <Text className='black_label' sx={{ width: '20%' }}>Default</Text>
                </Box>
                <Box className='blue-header'>
                    <Text className='white_label'>License Details</Text>
                </Box>
                <Box className='item-container'>
                    {licenseDetails.map((ele: FilterConfigItem, index: number) => (
                        <Box className='item-row' key={`filter_type_${index}`}>
                            <Text className='filter_text' sx={{ width: '60%' }}>{ele.label}</Text>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeLicenseDetails(index, 'invisible')}
                                    isChecked={!(ele?.invisible)}
                                />
                            </Box>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeLicenseDetails(index, 'default')}
                                    isChecked={!!(ele?.default)}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Box className='blue-header'>
                    <Text className='white_label'>Ratings</Text>
                </Box>
                <Box className='item-container'>
                    {ratings.map((ele: FilterConfigItem, index: number) => (
                        <Box className='item-row' key={`filter_type_${index}`}>
                            <Text className='filter_text' sx={{ width: '60%' }}>
                                {ratingListMapping[
                                    ele.value as string as keyType<
                                        typeof ratingListMapping
                                    >
                                ]}
                            </Text>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeRatings(index, 'invisible')}
                                    isChecked={!(ele?.invisible)}
                                />
                            </Box>
                            <Box sx={{ width: '20%' }}>
                                <CustomRadio
                                    name={'rating'}
                                    id={`rating-label-${index}`}
                                    value={ele.value as string}
                                    onChange={onChangeRatings(index, 'default')}
                                    isChecked={!!(ele?.default)}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Box className='blue-header'>
                    <Text className='white_label'>Reviews</Text>
                </Box>
                <Box className='item-container'>
                    {reviews.map((ele: FilterConfigItem, index: number) => (
                        <Box className='item-row' key={`filter_type_${index}`}>
                            <Text className='filter_text' sx={{ width: '60%' }}>{ele.label}</Text>
                            <Box sx={{ width: '20%' }}>
                                <Switch size="md" colorScheme="facebook"
                                    value={ele.value as string}
                                    onChange={onChangeReviews(index, 'invisible')}
                                    isChecked={!(ele?.invisible)}
                                />
                            </Box>
                            <Box sx={{ width: '20%' }}>
                                <CustomRadio
                                    name={'review'}
                                    id={`review-label-${index}`}
                                    value={ele.value as string}
                                    onChange={onChangeReviews(index, 'default')}
                                    isChecked={!!(ele?.default)}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
      </>
    )
}

export default FFLSelectFiltersConfiguration
